export default "__VITE_ASSET__Cx_IijKB__"